import { createFileRoute } from '@tanstack/react-router';

import termsHtml from '#features/static-pages/assets/terms-and-conditions.html?raw';
import termsRuHtml from '#features/static-pages/assets/terms-and-conditions.ru.html?raw';
import { EmbeddedHtmlPage } from '#features/static-pages/components/EmbeddedHtmlPage';
import { legalPageOverrides } from '#features/static-pages/constants/legalPageOverrides';
import { staticPageHead } from '#features/static-pages/utils/head';
import { withLegalEnhancements } from '#features/static-pages/utils/legalEnhancements';

const title = 'Terms and Conditions | Teamplay.gg';
const description =
  'Review the Terms and Conditions of Teamplay.gg to learn about the rules and guidelines for using our services.';

export const Route = createFileRoute('/{-$locale}/_layout/terms-and-conditions')({
  component: TermsAndConditionsPage,
  head: ({ params }) =>
    staticPageHead({
      title,
      description,
      pathname: '/terms-and-conditions',
      locale: params.locale,
      withRuLocale: true,
    }),
});

function TermsAndConditionsPage() {
  const { locale } = Route.useParams();
  const localePrefix = locale === 'ru' ? '/ru' : '';
  const html = locale === 'ru' ? termsRuHtml : termsHtml;
  const enhancedHtml = withLegalEnhancements(html, {
    fallbackUpdatedAt: 'Published on Teamplay.gg',
    quickLinks: [
      { href: `${localePrefix}/privacy-policy`, label: 'Privacy Policy' },
      { href: `${localePrefix}/terms-and-conditions`, label: 'Terms' },
      { href: `${localePrefix}/cookie-policy`, label: 'Cookie Policy' },
    ],
    tocTitle: locale === 'ru' ? 'Разделы' : 'On this page',
  });

  return (
    <EmbeddedHtmlPage
      html={enhancedHtml}
      title="Terms and Conditions"
      minHeight={1100}
      extraStyles={legalPageOverrides}
      runInlineScripts
      shellWidth="980px"
      showReadingProgress
      showBackToTop
      enableSectionAnchors
    />
  );
}
